import { useFliptBoolean } from '@flipt-io/flipt-client-react';
import PreviewImage from 'components/Modals/PreviewImage';
import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';
import { getConfig } from 'config/runtime';

const BASE_URL = getConfig('REACT_APP_IMAGES');

const SelectFieldImage = ({ label, value, onChange, disabled, onRemove }) => {
  const inputRef = useRef(null);
  const [showImage, setShowImage] = useState(false);

  const user = useSelector((state) => state.user.profile);
  const isNewUploadDocumentEnabled = useFliptBoolean('FLAG_FE_NEW_UPLOAD_DOCUMENT', false, user.id || 'anonymous');

  let valueInput = value;
  let valueImage = '';

  if (isNewUploadDocumentEnabled) {
    if (value && typeof value === 'object' && 'file' in value) {
      valueInput = value.name;
      valueImage = URL.createObjectURL(value.file);
    } else {
      valueImage = `${BASE_URL}${value}`;
    }
  } else {
    valueImage = Object.prototype.hasOwnProperty.call(value, 'name')
      ? URL.createObjectURL(value)
      : `${BASE_URL}${value}`;
  }

  return (
    <div className="select-field-image">
      <h4>{label}</h4>
      <div className="select-field-image__wrapper">
        <input type="file" accept="image/*" hidden ref={inputRef} onChange={onChange} />
        <input
          type="text"
          value={valueInput || ''}
          className="input-field"
          readOnly
          style={{ paddingRight: value ? (disabled ? '100px' : '180px') : '100px' }}
        />
        {value ? (
          <div className="btn-group">
            {!disabled ? (
              <button className="btn-item btn-delete" onClick={onRemove}>
                Hapus
              </button>
            ) : null}
            <button className="btn-item btn-show" onClick={() => setShowImage(true)}>
              Lihat
            </button>
          </div>
        ) : (
          <button className="btn-upload" onClick={() => inputRef.current.click()} disabled={disabled}>
            Browse..
          </button>
        )}
      </div>
      {showImage &&
        ReactDOM.createPortal(
          <PreviewImage image={valueImage} setShow={() => setShowImage(false)} />,
          document.getElementById('modal'),
        )}
    </div>
  );
};

export default SelectFieldImage;
